export enum REMOVE_DIALOG_ACTION {
  STOP_LOADING = 'StopLoading',
  CANCEL = 'Cancel',
}
